"use client";

import { linkResolver } from "@/helpers/link";
import { PrismicNextLink, PrismicNextLinkProps } from "@prismicio/next";

const AppLink = (props: PrismicNextLinkProps) => {
  return (
    <PrismicNextLink
      {...(props as any)}
      linkResolver={linkResolver}
      // linkResolver={(field) => {
      //   try {
      //     const segment = resolveSegment(getLocalFromPrismic(field.lang), field.type);

      //     let url = field.url;
      //     const lang = field.lang || "fr-fr"; // Default to 'fr-fr' if no lang is provided

      //     if (!url) {
      //       return "";
      //     }

      //     if (lang === "fr-fr") {
      //       url = url.replace(`/${lang}`, "");
      //     } else if (lang === "en-us") {
      //       url = url.replace(`/${lang}`, "/en");
      //     } else if (lang === "nl-be") {
      //       url = url.replace(`/${lang}`, "/nl");
      //     }

      //     if (segment && field.type) {
      //       const segmentInFR = resolveSegment(appLocales.defaultLocale, field.type);

      //       url = url.replace(`/${segmentInFR}`, `/${segment}`);

      //       // If url contains /faq/faq, replace it with /faq
      //       if (url.includes(`/${segment}/${segment}`)) {
      //         url = url.replace(`/${segment}/${segment}`, `/${segment}`);
      //       }
      //     }

      //     return url;
      //   } catch (error) {
      //     console.warn("Error resolving link:", error);
      //   }
      // }}
    />
  );
};

export default AppLink;
